var _rect, _rect2, _path, _path2, _rect3, _path3, _path4, _path5, _path6, _line, _rect4, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 177,
    viewBox: "0 0 150 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1081_18150)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.9175,
    y: 108.716,
    width: 52.9817,
    height: 64.6789,
    fill: "#D9C6C6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 120,
    width: 37,
    height: 18,
    rx: 2,
    fill: "#C5AAAA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5826 113.085C49.5826 112.053 49.5138 111.021 49.445 109.989L48.3096 96.9153C48.2408 95.9176 48.1032 94.9543 47.8968 93.9909L34.7546 94.0942H26.4977H26.3945H18.172L5.02982 93.9565C4.82339 94.9198 4.68578 95.9176 4.61697 96.8809L3.48165 109.954C3.37844 110.986 3.34404 112.018 3.34404 113.051L3 161.491H26.3945H26.4977H49.8922L49.5826 113.085Z",
    fill: "#AC949E"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1081_18150)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.587 84.2891H147.248L146.56 151.376H104.587V84.2891Z",
    fill: "#AC949E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 93,
    width: 37,
    height: 29,
    rx: 2,
    transform: "rotate(90 140 93)",
    fill: "#AC949E"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.349 51.9497C120.585 54.53 128.67 56.4222 133.314 51.9497",
    stroke: "#525252",
    strokeWidth: 3.44037,
    strokeMiterlimit: 10
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9564 26.9378H19.7133C17.5458 26.9378 15.7568 25.1833 15.7568 22.9814V5.64197C15.7568 3.47454 17.5114 1.68555 19.7133 1.68555H33.9564C36.1238 1.68555 37.9128 3.44013 37.9128 5.64197V22.9814C37.9128 25.1833 36.1582 26.9378 33.9564 26.9378Z",
    fill: "#AC949E",
    stroke: "#525252",
    strokeWidth: 3.44037,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.675 15.1378H119.848C117.896 15.1378 116.284 14.2295 116.284 13.0896V4.11274C116.284 2.99063 117.865 2.06445 119.848 2.06445H132.675C134.627 2.06445 136.239 2.97282 136.239 4.11274V13.0896C136.239 14.2295 134.658 15.1378 132.675 15.1378Z",
    fill: "#AC949E",
    stroke: "#525252",
    strokeWidth: 3.44037,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9197 113.085H48.1995L48.1996 113.094L49.9197 113.085ZM49.7821 109.988L51.4985 109.874L51.4973 109.857L51.4958 109.84L49.7821 109.988ZM48.6468 96.9151L46.9307 97.0334L46.9317 97.0487L46.9331 97.0639L48.6468 96.9151ZM48.2339 93.9908L46.5459 94.322L46.5488 94.3366L46.5519 94.3512L48.2339 93.9908ZM35.0917 27.0068L36.7797 26.6757L36.5072 25.2867H35.0917V27.0068ZM18.5092 27.0068V25.2867H17.0938L16.8212 26.6755L18.5092 27.0068ZM5.36697 93.9564L7.04897 94.3168L7.05208 94.3023L7.05494 94.2877L5.36697 93.9564ZM4.95413 96.8807L6.66786 97.0295L6.669 97.0164L6.66994 97.0033L4.95413 96.8807ZM3.81881 109.954L5.53046 110.125L5.53157 110.114L5.53254 110.103L3.81881 109.954ZM3.68119 113.05L5.40138 113.06V113.05H3.68119ZM50.2152 170.766L48.495 170.774L50.2152 170.766ZM51.6399 113.085C51.6399 111.986 51.5667 110.897 51.4985 109.874L48.0657 110.103C48.1352 111.145 48.1995 112.12 48.1995 113.085H51.6399ZM51.4958 109.84L50.3605 96.7663L46.9331 97.0639L48.0684 110.137L51.4958 109.84ZM50.3629 96.7967C50.2884 95.7161 50.1391 94.6719 49.9159 93.6304L46.5519 94.3512C46.7416 95.2363 46.8676 96.1187 46.9307 97.0334L50.3629 96.7967ZM49.9219 93.6596L36.7797 26.6757L33.4037 27.338L46.5459 94.322L49.9219 93.6596ZM35.0917 25.2867H26.8349V28.727H35.0917V25.2867ZM26.8349 25.2867H26.7317V28.727H26.8349V25.2867ZM26.7317 25.2867H18.5092V28.727H26.7317V25.2867ZM16.8212 26.6755L3.67901 93.625L7.05494 94.2877L20.1971 27.3382L16.8212 26.6755ZM3.68498 93.5959C3.46091 94.6416 3.31255 95.7189 3.23832 96.7581L6.66994 97.0033C6.73333 96.1158 6.86019 95.1978 7.04897 94.3168L3.68498 93.5959ZM3.2404 96.7319L2.10508 109.805L5.53254 110.103L6.66786 97.0295L3.2404 96.7319ZM2.10716 109.783C1.99655 110.889 1.96101 111.981 1.96101 113.05H5.40138C5.40138 112.055 5.43465 111.083 5.53046 110.125L2.10716 109.783ZM1.96104 113.041L1.63275 170.754L5.07306 170.774L5.40135 113.06L1.96104 113.041ZM6.10515 175.252H26.7317V171.812H6.10515V175.252ZM26.7317 175.252H26.8349V171.812H26.7317V175.252ZM26.8349 175.252H47.4629V171.812H26.8349V175.252ZM51.9354 170.757L51.6399 113.076L48.1996 113.094L48.495 170.774L51.9354 170.757ZM47.4629 175.252C49.942 175.252 51.9481 173.236 51.9354 170.757L48.495 170.774C48.498 171.347 48.035 171.812 47.4629 171.812V175.252ZM1.63275 170.754C1.61864 173.234 3.62513 175.252 6.10515 175.252V171.812C5.53284 171.812 5.0698 171.346 5.07306 170.774L1.63275 170.754Z",
    fill: "#525252"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22.5,
    y1: 116.537,
    x2: 31.2615,
    y2: 116.537,
    stroke: "#907580",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 125.573,
    width: 26,
    height: 24,
    rx: 2,
    fill: "#AC949E"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0986 62.9585C67.4312 69.6672 78.9564 76.72 91.8578 62.9585",
    stroke: "#525252",
    strokeWidth: 3.44037,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0726 76.909C93.7272 67.1565 89.4018 57.8342 87.6783 47.508C87.3066 45.285 82.9136 26 83.995 26C83.995 26 80.6834 26 78.2503 26C78.2503 26 77.1352 26 75.7497 26C73.3166 26 70.005 26 70.005 26C71.0864 26 66.6934 45.285 66.3217 47.508C64.5982 57.8342 60.2728 67.1565 56.9274 76.909C53.2103 87.6655 51.3179 98.6729 50 110.003V169.56C50 171.46 51.5403 173 53.4404 173H75.7497H78.2503H100.56C102.46 173 104 171.46 104 169.56V110.003C102.648 98.6729 100.756 87.6655 97.0726 76.909Z",
    stroke: "#525252",
    strokeWidth: 3.44037,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M146.122 71.7065C145.38 66.9895 143.49 62.4448 139.744 59.4149C136.672 56.9015 133.365 55.0079 133.365 50.4286C133.365 50.2909 133.365 15 133.365 15H128.673H123.341H118.65C118.65 15 118.65 50.2909 118.65 50.4286C118.65 55.0079 115.376 56.9015 112.271 59.4149C108.558 62.4448 106.635 66.9895 105.892 71.7065C104.238 82.2421 105.352 93.5352 105.555 104.209C105.791 115.777 106.027 127.311 106.263 138.88C106.297 140.911 106.5 172.966 106.635 172.966C106.635 172.966 106.635 172.966 106.635 172.966C106.635 172.966 116.895 172.966 123.341 173C123.341 173 124.387 173 126.007 173C127.627 173 128.673 173 128.673 173C135.041 173 145.235 172.966 145.378 172.966C145.383 172.966 145.378 172.969 145.381 172.965C145.482 172.821 145.717 140.907 145.751 138.88C145.987 127.311 146.224 115.777 146.46 104.209C146.662 93.5352 147.742 82.2421 146.122 71.7065Z",
    stroke: "#525252",
    strokeWidth: 3.44037,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.822 26.8349H70.9944C69.0424 26.8349 67.4312 25.0899 67.4312 22.9V5.65508C67.4312 3.49946 69.0114 1.72021 70.9944 1.72021H83.822C85.7741 1.72021 87.3853 3.46524 87.3853 5.65508V22.9C87.3853 25.0899 85.8051 26.8349 83.822 26.8349Z",
    fill: "#C0A5A5",
    stroke: "#525252",
    strokeWidth: 3.44037,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1081_18150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 176.147,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1081_18150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.7982,
    height: 157.913,
    fill: "white",
    transform: "translate(104.587 14.4497)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottles);
export default __webpack_public_path__ + "static/media/bottles.313b0b085d5632ce0c6d964986e7aa96.svg";
export { ForwardRef as ReactComponent };